const DownArrowIcon = () => {
    return(
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.3332 11.8333L3.99988 4.5" stroke="#30970B" stroke-width="1.0625" stroke-linecap="round"/>
        <path d="M12 7.83325V10.1666V11.7916C12 12.1255 12 12.2925 11.8962 12.3962C11.7925 12.4999 11.6256 12.4999 11.2916 12.4999H7.33331" stroke="#30970B" stroke-width="1.0625" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default DownArrowIcon